<template>
  <!--
    Service_Category filter for the Projects page (Requirement 6.3).

    Presents the fixed ThinkSpatial Service_Category taxonomy (plus the `All`
    option) as a chip group and emits the current selection. The component owns
    no filtering logic itself: the pure `filterByCategory` helper in
    client/src/services/serviceCategories.js applies the selection to a project
    list. The selectable options come from `CATEGORY_FILTER_OPTIONS` so the
    taxonomy stays defined in a single place rather than being redefined here.

    Supports `v-model` (via `modelValue` / `update:modelValue`) and additionally
    emits a `change` event carrying the selected category (or `All`).
  -->
  <v-chip-group
    :model-value="modelValue"
    selected-class="text-primary"
    mandatory
    column
    role="radiogroup"
    aria-label="Filter projects by service category"
    @update:model-value="onSelect"
  >
    <v-chip
      v-for="option in options"
      :key="option"
      :value="option"
      :text="option"
      variant="outlined"
      filter
    />
  </v-chip-group>
</template>

<script>
import {
  CATEGORY_FILTER_OPTIONS,
  ALL_CATEGORIES,
} from 'services/serviceCategories'

// ServiceCategoryFilter — emits the selected Service_Category (or `All`).
//
// The fixed enumeration and the `All` sentinel are imported from the canonical
// taxonomy module; this component does not redefine the categories.
export default {
  name: 'ServiceCategoryFilter',
  props: {
    // The currently selected category (enables `v-model`). Defaults to `All`.
    modelValue: {
      type: String,
      default: ALL_CATEGORIES,
    },
  },
  emits: ['update:modelValue', 'change'],
  computed: {
    // The selectable filter options: `All` followed by the fixed taxonomy.
    options() {
      return CATEGORY_FILTER_OPTIONS
    },
  },
  methods: {
    onSelect(value) {
      // `mandatory` keeps a selection at all times; fall back to `All` if the
      // chip group ever reports an empty selection.
      const selection = value == null ? ALL_CATEGORIES : value
      this.$emit('update:modelValue', selection)
      this.$emit('change', selection)
    },
  },
}
</script>
